var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayslipTotalEmployee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FFAF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4251_1986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3629 17.1267C28.2222 19.0798 26.7734 20.5844 25.1934 20.5844C23.6134 20.5844 22.1621 19.0803 22.0238 17.1267C21.8797 15.0948 23.2902 13.6689 25.1934 13.6689C27.0966 13.6689 28.507 15.1318 28.3629 17.1267Z",
    stroke: "white",
    strokeWidth: 1.53676,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1945 23.6582C22.0648 23.6582 19.0552 25.2127 18.3012 28.2402C18.2013 28.6407 18.4525 29.0369 18.864 29.0369H31.5255C31.9371 29.0369 32.1868 28.6407 32.0884 28.2402C31.3344 25.1642 28.3247 23.6582 25.1945 23.6582Z",
    stroke: "white",
    strokeWidth: 1.53676,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6629 17.9876C18.5506 19.5474 17.3798 20.7759 16.1177 20.7759C14.8556 20.7759 13.6829 19.5479 13.5724 17.9876C13.4576 16.3649 14.5972 15.2051 16.1177 15.2051C17.6381 15.2051 18.7777 16.3946 18.6629 17.9876Z",
    stroke: "white",
    strokeWidth: 1.53676,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9523 23.753C18.0855 23.3558 17.1308 23.2031 16.1189 23.2031C13.6217 23.2031 11.2157 24.4445 10.613 26.8625C10.5337 27.1824 10.7345 27.4989 11.063 27.4989H16.4551",
    stroke: "white",
    strokeWidth: 1.53676,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4251_1986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5882,
    height: 24.5882,
    fill: "white",
    transform: "translate(9.06055 9.05859)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayslipTotalEmployee);
export default __webpack_public_path__ + "static/media/payslip-total-employee.e7c0e43c5edf4e1c5e489685ea066690.svg";
export { ForwardRef as ReactComponent };